import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { useSelector, useDispatch } from 'react-redux';
import { resultActions } from '../../redux/actions'

import ReactGA from 'react-ga'

import { Container, Row, Col, Button, Modal } from 'reactstrap'

import { ResultValues, ResultThemes, ResultNextSteps, ResultTitles, Appendix } from './'

import { allowNextSteps, getPrintBrandLogo, getBrandCoverImage } from '../Branding'
import { Loading } from '../Utils/Loading'
import { Fulfillment } from './Fulfillment';

export const ResultReportPage = () => {
    const { isAssessed, core_values, support_values, drivers, qualifiers, themes, date_created, user } = useSelector(store => store.results)
    //todo add dispatch/selector for additional demo information for name and such here
    const demo = user ? {
        name: `${user.first_name} ${user.last_name}`,
        date: new Date(date_created).toLocaleString('en-US', {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
        position: user.position,
        years: user.time_at_position
    } : null 
    
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resultActions.get())
    },[])

    if(isAssessed) {
        return <ResultReport
            coreValues={core_values}
            supportValues={support_values}
            drivers={drivers}
            characterValues={qualifiers}
            themes={themes}
            demo={demo}
        />
    } else {
        return <Loading />
    }
}

export const ResultReport = ({coreValues, supportValues, drivers, characterValues, themes, demo}) => {
    const contentRef = useRef(null)
    const Logo = getPrintBrandLogo()
    const CoverImg = getBrandCoverImage()
    // Print margins are controlled by the browser, but we can make them consistent across pages
    // by providing an explicit @page margin for this print job.
    const pageStyle = `
        @page {
            /* Match "reasonable" default print margins and keep them consistent across pages */
            margin: 0.75in;
        }

        @media print {
            html, body {
                margin: 0 !important;
                padding: 0 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            /* Ensure the table uses the full printable area within @page margins */
            #result-report-table {
                width: 100%;
                border-collapse: collapse;
            }
        }
    `

    // Prevent the browser's header/footer from picking up an app/page title where possible.
    // Note: the URL/date/page# footer itself is controlled by the browser print dialog ("Headers and footers").
    const printFn = useReactToPrint({ contentRef, pageStyle, documentTitle: '' })

    const popupPrint = async () => {
        await new Promise(resolve => setTimeout(resolve, 1000))
        printFn()
        //window.print()
    }

    useEffect(() => {
        const handleLoad = () => {
            console.log('All window resources loaded!');
            popupPrint()
        };

        if (document.readyState === 'complete') {
            handleLoad();
        } else {
            window.addEventListener('load', handleLoad);
        }

        return () => {
            window.removeEventListener('load', handleLoad);
        }
    },[])

    const hasValues = (coreValues || supportValues || drivers || characterValues) ? true : false
    const hasThemes = (themes) ? true : false
    const titleCount = themes.reduce((a, b) => {
        if(b.jobs) a += b.jobs.length
        return a
    }, 0)
    const hasTitle = titleCount ? true : false

    const CoverPage = () => {
        //return <div />
        return (
            <Container style={{pageBreakAfter: "always"}}>
                <div style={{pageBreakAfter: "always"}}>
                <Row><Col style={{padding: '37px'}}>
                  <Row><Col style={styles.colTitle} sm="2">Date: </Col><Col>{demo.date}</Col></Row>
                  <Row><Col style={styles.colTitle} sm='2'>Results For: </Col><Col>{demo.name}</Col></Row>
                  {demo.position && <Row><Col style={styles.colTitle} sm='2'>Job Title: </Col><Col>{demo.position}</Col></Row>}
                  {demo.years && <Row><Col style={styles.colTitle} sm='2'>Time in Job Role: </Col><Col>{demo.years}</Col></Row>}
                </Col></Row>
                    <img src={CoverImg} />
                </div>
            </Container>
        )
    }

    const Header = () => {
        return (
            <Container style={{paddingTop: '50px'}}>
                <div><Logo /></div>
            </Container>
        )
    }

    const Footer = () => {
        return (
            <Container className="page-footer text-center">
                <hr />
                &copy; 2000 - {new Date().getFullYear()} Careerz Group. All Rights Reserved.
            </Container>
        )
    }

    return (
        <div ref={contentRef}>
            <Container>
                <Container style={{padding: "0px"}}>
                    <Row style={{width: "100%", margin: "0px", padding: "0px"}} >
                        <Col>
                            <Container>
                                <table id="result-report-table">
                                    <thead><tr><td>
                                        <div className="header-space"><Header /></div>
                                    </td></tr></thead>
                                    <tbody><tr><td>
                                        <CoverPage />
                                        <br  style={{pageBreakAfter: "always"}}/>
                                        <div style={{margin: '0px'}}>&nbsp;</div>
                                        { hasValues &&
                                            <ResultValues
                                                coreValues={coreValues}
                                                supportValues={supportValues}
                                                drivers={drivers}
                                                characterValues={characterValues}
                                            />
                                        }
                                        { hasThemes &&
                                            <ResultThemes themeList={themes} />
                                        }
                                        {hasTitle &&
                                            <ResultTitles themeList={themes} />
                                        }
                                        <Fulfillment />
                                        { allowNextSteps() &&
                                            <ResultNextSteps />
                                        }
                                        <Appendix />
                                        <br />
                                    </td></tr></tbody>
                                    <tfoot><tr><td>
                                        <div className="footer-space"><Footer /></div>
                                    </td></tr></tfoot>
                                </table>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}

export const ResultReportButton = (props) => {

    const [modal, setModal] = useState(false)

    const toggle = () => {

        if(!modal) {
            //going to display
            ReactGA.pageview('result_report')
        }

        setModal(!modal)
    }

    return (
        <Fragment>
            <Button onClick={toggle} style={{cursor: "pointer"}}>Print Report</Button>
            <Modal isOpen={modal} toggle={toggle} modalClassName="modal-fullscreen">
                <ResultReport {...props} />
            </Modal>
        </Fragment>
    )
}

const styles = {
    colTitle: {
        fontWeight: 'bold',
        color: '#007bff'
    }
}
